var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 182,
    rx: 40,
    fill: "#54ADFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.826 177.301C155.216 180.3 148.806 182 142 182H39.9999C33.1938 182 26.7846 180.3 21.174 177.302C21.0219 176.694 20.9676 176.06 21.0187 175.421C21.1468 173.814 21.9388 172.335 23.1968 171.322C27.2386 168.121 32.1772 165.839 37.5003 164.709L63.0672 159.586C65.7578 159.063 67.703 156.664 67.703 153.881V148.025C66.0935 145.777 64.5623 142.803 62.9559 139.682L62.8575 139.491C61.5763 136.999 59.6311 133.227 58.7691 132.342C53.5043 127.08 48.5074 121.235 46.9699 113.702C45.514 106.623 46.9932 102.897 48.4958 99.9634L48.6472 95.7603C48.4841 88.7746 48.2861 80.0774 50.243 74.7799C56.5561 57.3854 75.4138 47.6287 90.754 47C98.0804 47.1281 104.219 48.7697 110.427 52.1229C111.126 52.4954 113.025 52.8214 114.399 53.0543C117.905 53.6481 122.261 54.3932 125.22 57.595C129.413 62.1124 131.079 67.2702 131.288 76.4448C133.047 83.2209 133.28 92.5352 133.28 99.975C134.946 102.956 136.367 106.658 134.922 113.714C133.373 121.235 128.376 127.068 123.205 132.261C122.261 133.227 120.363 136.964 119.105 139.444C117.486 142.646 115.937 145.708 114.294 148.013V153.87C114.294 156.664 116.228 159.062 118.907 159.575L144.45 164.698C149.808 165.815 154.747 168.121 158.8 171.322C160.058 172.324 160.85 173.802 160.979 175.409C161.034 176.051 160.98 176.69 160.826 177.301Z",
    fill: "#9DCEFC",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoDefault);
export default __webpack_public_path__ + "static/media/photo-default.538c73d95e2135d085724985eac5272f.svg";
export { ForwardRef as ReactComponent };